// extracted by mini-css-extract-plugin
export var ad = "copy-container-module--ad--e20be";
export var button = "copy-container-module--button--b4925";
export var center = "copy-container-module--center--2bbf1";
export var copyContainer = "copy-container-module--copyContainer--f494a";
export var copyContainer__centered = "copy-container-module--copyContainer__centered--f9457";
export var copyContainer__color = "copy-container-module--copyContainer__color--f2f79";
export var copyContainer__left = "copy-container-module--copyContainer__left--9986e";
export var copyContainer__light = "copy-container-module--copyContainer__light--367ec";
export var copyContainer__right = "copy-container-module--copyContainer__right--f128a";
export var h1 = "copy-container-module--h1--cbbe0";
export var h2 = "copy-container-module--h2--d92af";
export var h3 = "copy-container-module--h3--f74f1";
export var h4 = "copy-container-module--h4--a42f8";
export var h5 = "copy-container-module--h5--3cc0f";
export var h6 = "copy-container-module--h6--a3177";
export var image = "copy-container-module--image--7f984";
export var imageLink = "copy-container-module--imageLink--60cbb";
export var membershipLogo = "copy-container-module--membershipLogo--4aac9";
export var small = "copy-container-module--small--f809b";
export var social = "copy-container-module--social--e7388";
export var socialIcons = "copy-container-module--socialIcons--2e0ee";
export var spin = "copy-container-module--spin--dc3d3";
export var standalone = "copy-container-module--standalone--2a669";